import { useMemo, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import COMPONENT_LIST_SETS  from '../queries/COMPONENT_LIST_SETS';

const useComponentListSets = () => {
    const [ fetchCLS, { data, loading, error } ] = useLazyQuery( COMPONENT_LIST_SETS );
    
    useEffect( () => {
        loadCLS();
    }, [] );
    
    const clsData = useMemo( () => {
        if ( data?.componentListSets?.edges ) {
            return data.componentListSets.edges.map( i => {
                return { ...i.node, key: i.node.componentListSetId }
            } );
        } else {
            return [];
        }
    }, [ data ] );
    
    const loadCLS = () => {
        const vars = {
            fetchPolicy: 'network-only' 
        };

        return fetchCLS( vars );
    };

    return useMemo( () => {
        return {
            loadCLS,
            clsData,
            clsError: error,
            clsLoading: loading
        };
    }, [ fetchCLS, clsData, error, loading ] );
};

export default useComponentListSets;
